/** Settings › Keyboard shortcuts: the list, the editor and the shortcut names. */
export default {
  hintDesktop: "Click an action to try it, or its keys to change them",
  hintWeb: "Click a shortcut to change it",
  helpCommunity: "Get help in the WhatsApp community",
  linkFailed: "That link couldn’t open. Please try again.",
  customShortcut: "Custom shortcut",
  changeShortcut: "Change {name} shortcut",
  recordScreen: "Record screen",
  recordScreenDetail:
    "While listening or the input bar is open. Draw if needed; release to save.",
  holdCapsLock: "Hold Caps Lock",
  moreShortcuts: "More shortcuts",
  fewerShortcuts: "Fewer shortcuts",
  groupInput: "Input",
  groupWorkspace: "Workspace",
  platformShortcuts: "{platform} shortcuts",
  resetAll: "Reset all",
  unavailable: "Shortcut unavailable.",
  defaultShortcut: "Default shortcut",
  yourShortcut: "Your shortcut",
  recordNew: "Record a new shortcut",
  settingNew: "Setting a new shortcut…",
  clickToSet: "Click to set a new shortcut",
  pressKeys: "Press keys, or double-tap a modifier",
  thenPress: "Then press your keys",
  currently: "Currently: {shortcut}",
  defaultInUse: "The default is already in use, set your own",
  usingDefault: "Using the default shortcut",
  resetToDefault: "Reset to default",
  noShortcut: "No shortcut assigned",
  keyboard: "{platform} keyboard, {keys}",
  labelToggleWorkspace: "Show / Hide workspace",
  labelInputOpen: "Open input bar",
  labelVoiceToggle: "Start / Stop voice input",
  labelDictationAnywhere: "Dictation anywhere",
  labelDraw: "Draw and take screenshots",
  labelVoiceContinuous: "Hands-free voice",
  labelVoiceNew: "Voice input in a new chat",
  labelVoiceCancel: "Cancel voice input",
  labelSpeechStop: "Stop spoken response",
  labelWorkspacePeek: "Pan workspace",
  labelFrameMultiselect: "Select multiple frames",
  contextDictationAnywhere: "Works in any app. Press it again to stop.",
  contextDraw: "While listening or the floating input bar is open",
  contextVoiceCancel: "During recording or hands-free voice",
  contextSpeechStop: "While Denker is speaking",
  contextWorkspacePeek: "Drag to move around the workspace",
  contextFrameMultiselect: "Click a frame while holding the modifier",
  claudeClashRow:
    "The Claude app{profiles} also uses this shortcut. Turning it off restarts Claude if it’s open.",
  claudeClashTitle: "Same shortcut as the Claude app",
  claudeClashToast:
    "{shortcut} is also used by the Claude app{profiles}. Turn it off in Claude: {path}.",
  claudeRunningToast: "Claude{profiles} also uses {shortcut|lower}.",
  restartClaudeTurnOff: "Restart Claude and turn it off",
  claudeOffTitle: "Turned off Claude’s shortcut",
  claudeOffToast:
    "Claude{profiles} also used {shortcut|lower}, so Denker turned off Claude’s {setting}.",
  /** After "Claude" when it runs several profiles: which ones, by folder. */
  claudeProfiles: " ({names})",
  claudeOffFailed:
    "Couldn’t change Claude’s settings. Turn it off in Claude: {path}.",
  claudeQuitFailed:
    "Claude is still working and didn’t quit. Once you quit it, Denker turns the shortcut off.",
  turnOffInClaude: "Turn off in Claude",
  useAnotherKey: "Use another key for Denker",
  showShortcuts: "Show shortcuts",
} as const;
